import React from "react";
import { Package } from "react-feather";
import SectionCard from "../../../../components/common/SectionCard";
import { formatQty } from "../surveyStatusMaps";

// Read-only materials list. Products - description and unit come from the product
// master (filled by the server on save). Batch224: then the service template's
// product-group lines with the technician's quantity.
const SurveyMaterialsCard = ({ lines = [], groupLines = [], right }) => {
  const count = lines.length + groupLines.length;
  const totalQty = [...lines, ...groupLines].reduce((sum, l) => sum + Number(l.qty || 0), 0);
  return (
    <SectionCard
      icon={Package}
      title="Materials"
      right={
        <span className="d-inline-flex align-items-center gap-2">
          <span className="badge badge-linesecondary">{count}</span>
          {right}
        </span>
      }
    >
      {count === 0 ? (
        <p className="text-muted small mb-0">No materials recorded.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm align-middle mb-0">
            <thead>
              <tr>
                <th style={{ width: 40 }}>#</th>
                <th>Product</th>
                <th className="text-end" style={{ width: 90 }}>Qty</th>
                <th style={{ width: 80 }}>Unit</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {lines.map((l, i) => (
                <tr key={`${l.lineNumber}-${i}`}>
                  <td className="text-muted">{l.lineNumber || i + 1}</td>
                  <td className="fw-semibold">{l.description || `Product ${l.productCode}`}</td>
                  <td className="text-end fw-semibold">{formatQty(l.qty)}</td>
                  <td>{l.unit || "-"}</td>
                  <td className="small">{l.remarks || <span className="text-muted">-</span>}</td>
                </tr>
              ))}
              {groupLines.length > 0 && (
                <tr>
                  <td colSpan={5} className="small text-muted text-uppercase fw-semibold pt-3" style={{ letterSpacing: 0.5 }}>
                    Product groups
                  </td>
                </tr>
              )}
              {groupLines.map((g, i) => (
                <tr key={`g-${g.lineNumber}-${i}`}>
                  <td className="text-muted">{lines.length + i + 1}</td>
                  <td>
                    <span className="fw-semibold">{g.description}</span>
                    {g.groupName && g.groupName !== g.description && <div className="small text-muted">Group: {g.groupName}</div>}
                  </td>
                  <td className="text-end fw-semibold">{formatQty(g.qty)}</td>
                  <td>{g.unit || "-"}</td>
                  <td className="small"><span className="badge bg-light text-dark border">Group</span></td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td />
                <td className="text-muted small">Total</td>
                <td className="text-end fw-bold">{formatQty(totalQty)}</td>
                <td colSpan={2} />
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </SectionCard>
  );
};

export default SurveyMaterialsCard;
